import { useSelector } from 'react-redux';
import { cartCurrencySelector } from '../redux/selectors/cartSelector';
import React from 'react';
import getDiscountAmountByTariffAndPeriod from '../resolvers/getDiscountAmountByTariffAndPeriod';
import { PRODUCT_DB_API_LABEL_FORMATTER } from '../constants/constants';

export default function usePricePerPeriod() {
    const currency = useSelector((state) => cartCurrencySelector(state));
    const sign = <span dangerouslySetInnerHTML={{ __html: currency?.sign }}></span>;

    const pricePerPeriod = (tariff, period = null) => {
        const discount = getDiscountAmountByTariffAndPeriod(tariff, period, currency.rate);
        const price = tariff?.cost - discount;
        const priceInCurrentCurrency =
            Math.round((price * currency?.rate + Number.EPSILON) * 100) / 100;
        const billing_period = tariff?.billing_period;
        let tariffName = tariff?.name;
        // For DB API price per period uses a different approach.
        if (tariff?.product_id === 2) {
            tariffName = PRODUCT_DB_API_LABEL_FORMATTER.replacer(
                PRODUCT_DB_API_LABEL_FORMATTER.optionLabel,
                PRODUCT_DB_API_LABEL_FORMATTER.match.exec(tariffName)
            );
        } else if (tariff?.product_id === 7) {
            tariffName = `${tariff?.name} & ${tariff?.storage} GB Storage`;
        }

        return (
            tariff?.name.includes('Project')
            ? <>
                {tariffName},&nbsp;
                <span className={'filter-label__tariff-price'}>
                    {sign}
                    {priceInCurrentCurrency}/{billing_period}
                </span>
                {tariff?.allow_subscribe ? '' : ' *'}
                {tariff.current_tariff ? (
                    <span className={'filter__tarrif-notes pl-4'}>(current)</span>
                ) : null}
            </>
            : <>
                    {tariff?.name},&nbsp;
                    <span className={'filter-label__tariff-price'}>
                    {sign}
                        {priceInCurrentCurrency}/{billing_period}
                </span>
                    {tariff?.allow_subscribe ? '' : ' *'}
                    {tariff.current_tariff ? (
                        <span className={'filter__tarrif-notes pl-4'}>(current)</span>
                    ) : null}
                </>
        );
    };

    return pricePerPeriod;
}
